import $$ from 'cmn-utils'
import event from "./event"
import alarm from "./alarm"
import action from "./action"
import state from "./state"
import part from "./part"
import product from "./product"
import {formatSearchData} from "@/utils/format";


const baseUrl = "/api/device/";
export default {
    disRing: (params) => {
        return $$.post(baseUrl + 'dis-ring', params)
    },
    changeState: (params) => {
        return $$.post(baseUrl + 'change-state', params)
    },
    total: (params) => {
        formatSearchData(params)
        return $$.get(baseUrl + 'total', params)
    },
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    downloadResult: (params) => {
        return $$.get(baseUrl + 'download-result', params)
    },
    exportExcel: (params) => {
        return $$.get(baseUrl + 'export-excel', params)
    },
    get: function get(params) {
        return $$.get(baseUrl + 'get', params)
    },
    handleAlarm: (params) => {
        return $$.post(baseUrl + 'handle-alarm', params)
    },
    importExcel: (data, formData) => {
        let url = baseUrl + 'import-excel'
        if (data) {
            let paramsArray = []
            //拼接参数
            Object.keys(data).forEach(key => paramsArray.push(key + '=' + data[key]))
            if (url.search(/\?/) === -1) {
                url += '?' + paramsArray.join('&')
            } else {
                url += '&' + paramsArray.join('&')
            }
        }
        return $$.post(url, formData,
            {
                headers: {
                    "content-type": "multipart/form-data;boundary=" + new Date().getTime()
                    , ...$$.getStore("headers")
                }
            });
    },
    list: (params) => {
        if (params.startTime) {
            params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endTime) {
            params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
        }
        formatSearchData(params)
        return $$.get(baseUrl + 'list', params)
    },
    listMain: (params) => {
        return $$.get(baseUrl + 'list-main', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    getActionBindProp: (params) => {
        return $$.get(baseUrl + 'get-action-bind-prop', params)
    },
    getAction: (params) => {
        return $$.get(baseUrl + 'get-action', params)
    },
    getLastActionParams: (params) => {
        return $$.get(baseUrl + 'get-last-action-params', params)
    },
    replaceDevice: (params) => {
        return $$.post(baseUrl + 'replace-device', params)
    },
    send: {
        action: (params) => {
            return $$.post(baseUrl + 'send/action', params)
        },
    },
    otherAction: {
        list: (params) => {
            return $$.get(baseUrl + 'other-action/list', params)
        },
    },
    event, alarm, action, state, part, product

}